/**
  Updates dynamic elements based on a trigger element's dataset.
  @param {HTMLElement} trigger - The element that triggered the update.
  @param {Array<HTMLElement>} allDynamicElems - An array of all dynamic elements to be updated.
  @returns {void}
*/

export const updateDynamicElems = (
  trigger,
  allDynamicElems,
  formEl = false
) => {
  if (!trigger || !allDynamicElems) {
    console.warn("Missing arguments for updateDynamicElems.");
    return;
  }

  const { dataset } = trigger;

  allDynamicElems.forEach((dynamicEl) => {
    // eslint-disable-next-line no-prototype-builtins
    if (dataset.hasOwnProperty(dynamicEl.dataset.update)) {
      const newProperty = dynamicEl.dataset.update;

      switch (newProperty) {
        case "image":
          dynamicEl.src = dataset[newProperty];
          dynamicEl.alt = dataset.title;
          break;
        case "variant":
          if (formEl) {
            formEl.dataset.productVariant = dataset[newProperty];
          }
          dynamicEl.value = dataset[newProperty];
          break;
        case "handle":
          dynamicEl.dataset.handle = dataset[newProperty];
          break;
        default:
          if (!dynamicEl.children || !dynamicEl.children.length) {
            dynamicEl.innerText = dataset[newProperty];
          } else {
            dynamicEl.children[dynamicEl.children.length - 1].innerText =
              dataset[newProperty];
          }
      }
    }
  });
};
